const REQUEST_STATUS = [
  {
    value: 'new',
    translationKey: 'status.new',
    type: 'primary',
  },
  {
    value: 'open',
    translationKey: 'status.open',
    type: 'primary',
  },
  {
    value: 'confirmed',
    translationKey: 'status.confirmed',
    type: 'warning',
  },
  {
    value: 'done',
    translationKey: 'status.done',
    type: 'success',
  },
  {
    value: 'cancelled',
    translationKey: 'status.cancelled',
    type: 'secondary',
  },
  {
    value: 'rejected',
    translationKey: 'status.rejected',
    type: 'danger',
  },
  {
    value: 'active',
    translationKey: 'status.active',
    type: 'success',
  },
  {
    value: 'inactive',
    translationKey: 'status.inactive',
    type: 'primary',
  },
];

export default REQUEST_STATUS;
